






import {Component, Mixins} from "vue-property-decorator";
import AnalyticsMixin from "@mixins/AnalyticsMixin";

import MeetingSlot from "@share/meetings-schedule/components/meeting-slot/MeetingSlot.vue";
import MeetingsSchedule from "@share/meetings-schedule/MeetingsSchedule.vue";

@Component({
    name: 'MeetingsScheduleView',
    components: { MeetingsSchedule, MeetingSlot }
})
export default class ParticipantsView extends Mixins(AnalyticsMixin) {

}
